import { Routes } from '@angular/router';
import { ErrorComponent } from './error/error.component';
import { SignatureCompletedComponent } from './signature-completed/signature-completed.component';
import { IssueSignComponent } from './issue-sign/issue-sign.component';
import { OneShotRegisterComponent } from './one-shot-register/one-shot-register.component';
import { signProcessGuard } from './_guards/sign-process.guard';
import { LoaderComponent } from './loader/loader.component';
import { taskDataGuard } from './_guards/task-data.guard';

export const routes: Routes = [
  {
    path: ':praticaId/process/:processId',
    canActivate: [signProcessGuard],
    children: [
      {
        path: 'oneshot-register/:oneshotRegisterId',
        component: OneShotRegisterComponent,
        canActivate: [taskDataGuard],
      },
      {
        path: 'issue-sign/:issueSignId',
        component: IssueSignComponent,
        canActivate: [taskDataGuard],
      },
      {
        path: 'complete',
        component: SignatureCompletedComponent,
      },
    ],
  },

  { path: 'error', component: ErrorComponent },
  { path: '**', redirectTo: 'error' },
];
